/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:17/01/2021
 @Time:08:58
 **/
import Langue from "../../../i18n/service/LangueService";
import LangueService from "../../../i18n/service/LangueService";

export default class User {


    constructor() {

        /**
         *
         * @type {String}
         * @private
         */
        this._id = null;

        /**
         * @type {{}}
         * @private
         */
        this._nom = {}

        /**
         *
         * @type {{}}
         * @private
         */
        this._prenom = {}

    }

    /**
     *
     * @param {string} locale - locale format fr_FR
     * @param {string} nom
     * @returns {User}
     */
    addTraductionNom(locale, nom) {
        this._nom[locale] = nom;
        return this;
    }

    /**
     *
     * @param {string} locale - locale format fr_FR
     * @param {string} prenom
     * @returns {User}
     */
    addTraductionPrenom(locale, prenom) {
        this._prenom[locale] = prenom;
        return this;
    }

    /**
     *
     * @param {string} locale - locale format fr_FR
     * @returns {User}
     */
    removeTraductionPrenom(locale) {
        (this._prenom.hasOwnProperty(locale)) ? this._prenom.deleteProperty(locale) : null;
        return this;
    }

    /**
     *
     * @param {string} locale - locale format fr_FR
     * @returns {User}
     */
    removeTraductionNom(locale) {
        (this._nom.hasOwnProperty(locale)) ? this._nom.deleteProperty(locale) : null;
        return this;
    }

    /**
     *
     * @param {string} id  - UUID de l'utilisateur
     * @returns {User}
     */
    set id(id) {
        this._id = id;
        return this;
    }

    get id() {
        return this._id;
    }


    getNom(locale) {
        return this._nom.hasOwnProperty(locale) ? this._nom[locale] : null;
    }

    getPrenom(locale) {
        return this._prenom.hasOwnProperty(locale) ? this._prenom[locale] : null;
    }

    /**
     *
     * @param {{}}userJson utilisateur format json (JAKSON SPRING)
     * @returns {User} instance de la classe User
     */
    static createFromUserJson(userJson) {
        let user = null;
        if (userJson != null) {
            let user = new User();
            user.id = userJson.id;
            let langues = LangueService.getInstance().langues;
            if (userJson.userLocalizations != null) {
                for (let i in langues) {
                    let langue = langues[i];
                    user.addTraductionNom(langue.locale, userJson.userLocalizations[langue.locale].nom).addTraductionPrenom(langue.locale, userJson.userLocalizations[langue.locale].prenom);
                }
            }
        }
        return user;
    }
}